module.exports = {
      id: "subscribe-vikatan-usage",
      viewBox: "0 0 365.232 27",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#subscribe-vikatan",
      toString: function () {
        return this.url;
      }
    }